export const signalLoading = (state, payload) => {
    state.loading = payload
}

export const listSignal = (state, payload) => {
    if(payload.data){
        state.signals = payload.data
    }
    state.signalStatus = payload
}

export const signalDetail = (state, payload) => {
    if(payload.data){
        state.signalDetail = payload.data
    }
    state.signalStatus = payload
}

export const postponeSignals = (state, payload) => {
    if(payload.data){
        state.postponeSignals = payload.data
    }else{
        state.postponeSignals = []
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/Alarmsis/Signal/Mutations.js